<template>
  <div class="appDetail">
    <div class="grayBg clearfix">
      <ul class="w1200 index">
        <li>
          <a href="/">中企门户</a>&nbsp;>&nbsp;</li>
        <li>
          <a href="/domain">企业域名</a>&nbsp;>&nbsp;</li>
        <li>
          <a href="javascript:;">域名介绍</a>
        </li>
      </ul>
      <div class="w1200">
        <div class="base-line">
          <div class="base-line-div w1200">
            <div class="protect-right">
              <h2 class="pt-h1">价格清单</h2>
              <p>
                <b>总价：</b>
                <strong>
                  <i>{{initData.minPrice}}</i>元</strong>
              </p>
              <!-- <s v-if="initData.guidePrice">{{initData.guidePrice}}元</s> -->
              <h2 class="pt-h2">所选配置</h2>
              <ul>
                <li>
                  <b>绑定域名</b>
                  <span>{{checkedDomain_show}}</span>
                </li>
                <li v-if="buyType.unitNumData.status == true">
                  <b>购买数量</b>
                  <span>{{postData.goodsNum}}{{buyType.unitNumData.unit}}</span>
                </li>
                <li v-if="buyType.unitTimeData.status == true">
                  <b>选购时常</b>
                  <span>{{postData.timeLong}} 个月</span>
                </li>
              </ul>
              <!-- <h2 class="pt-h3">优惠政策</h2>
            <div class="youhui">whois保护购买满3个域名，总价减1.5元</div>
            <a href="">点击领取优惠券 ＞</a> -->

              <a href="https://tb.53kf.com/code/client/10168926/3" class="kf53zx bt" target="_blank">在线咨询</a>
            </div>
          </div>
        </div>
        <div class="protect-left">
          <h2>人工服务</h2>
          <a :href="'/domain/app-detail/'+MatchProId['MANMADE_REALNAME']">实名制认证</a>
          <a :href="'/domain/app-detail/'+MatchProId['MANMADE_PASS_DOMAIN']">域名所有人过户</a>
          <a :href="'/domain/app-detail/'+MatchProId['MANMADE_DOMAIN_RESOLUTION']">域名解析调整</a>
          <a :href="'/domain/app-detail/'+MatchProId['MANMADE_MODIFY_DNS']">域名DNS修改</a>
          <h2>域名解析</h2>
          <a :href="'/domain/app-detail/'+MatchProId['ENTERPRICE_DNS']">高级版DNS</a>
          <h2>增值应用</h2>
          <a :href="'/domain/app-detail/'+MatchProId['WHOIS']">whois信息保护</a>
          <a :href="'/domain/app-detail/'+MatchProId['DOMAIN_SECRURITY_LOCK']">域名安全锁</a>
        </div>
        <div class="protect-center">
          <div class="cen-top">
            <div v-if="pCode == MatchProId['MANMADE_MODIFY_DNS']"
                 class="">
              <img class="bgGreen inbl pro-img"
                   src="../static/assets/icon-modify-dns.png">
              <div class="pro-title inbl top">
                <div class="pro-title-name">域名DNS修改</div>
                <p>人工协助用户完成域名DNS服务器变更，即中企DNS变更为非中企或非中企DNS变更为中企DNS</p>
                <div class="">
                  <p>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">30分钟响应服务</span>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">域名服务专家，1对1服务</span>
                  </p>
                  <p>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">一次提交，成功率高</span>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">对结果负责，域名DNS变更可正常访问，服务截至</span>
                  </p>
                </div>
              </div>
            </div>
            <div v-if="pCode == MatchProId['MANMADE_DOMAIN_RESOLUTION']"
                 class="">
              <img class=" bgGreen pro-icon inbl"
                   src="../static/assets/icon-resolution.png">
              <div class="pro-title inbl top">
                <div class="pro-title-name">域名解析调整</div>
                <p>人工协助用户完成域名解析记录的增、删、改等操作</p>
                <div class="">
                  <p>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">30分钟响应服务</span>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">域名服务专家，1对1服务</span>
                  </p>
                  <p>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">一次提交，成功率高</span>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">对结果负责，域名解析记录变更并存储，服务截至</span>
                  </p>
                </div>
              </div>
            </div>
            <div v-if="pCode == MatchProId['MANMADE_PASS_DOMAIN']"
                 class="">
              <img class=" bgGreen pro-icon inbl"
                   src="../static/assets/icon-pass.png">
              <div class="pro-title inbl top">
                <div class="pro-title-name">域名所有人过户</div>
                <p>即注册域名从一个所有者过户到另一个实名认证通过的所有者模板下</p>
                <div class="">
                  <p>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">30分钟响应服务</span>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">域名服务专家，1对1服务</span>
                  </p>
                  <p>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">一次提交，成功率高</span>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">对结果负责，直至域名所有者过户成功，服务截至</span>
                  </p>
                </div>
              </div>
            </div>
            <div v-if="pCode == MatchProId['MANMADE_REALNAME']"
                 class="">
              <img class="bgGreen pro-icon inbl"
                   src="../static/assets/icon-realname.png">
              <div class="pro-title inbl top">
                <div class="pro-title-name">实名制认证</div>
                <p>即域名提供的注册信息等要经过注册机构审核，只有实名认证审核通过才能正常使用！</p>
                <div class="">
                  <p>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">30分钟响应服务</span>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">域名服务专家，1对1服务</span>
                  </p>
                  <p>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">一次提交，成功率高</span>
                    <img src="../static/assets/checked.png"
                         alt="">
                    <span class="inbl">对结果负责，直至实名审核通过，服务截至</span>
                  </p>
                </div>
              </div>
            </div>
            <div v-if="pCode == MatchProId['ENTERPRICE_DNS']"
                 class="">
              <img class=" bgGreen inbl pro-img"
                   src="../static/assets/icon-enterprice-dns.png">
              <div class="pro-title inbl top">
                <div class="pro-title-name">高级版DNS</div>
                <p>拥有防御攻击能力的DNS服务，是基础DNS服务 （域名解析）+防御能力（抵制DNS查询攻击）的域名增值服务产品。</p>
              </div>
            </div>
            <div v-if="pCode == MatchProId['WHOIS']"
                 class="">
              <img class=" bgGreen inbl pro-img"
                   src="../static/assets/icon-WhoIs.png">
              <div class="pro-title inbl top">
                <div class="pro-title-name">WhoIs信息保护</div>
                <p>保护域名的注册信息不被公开，让企业远离垃圾邮件和电话骚扰。</p>
                <p class="red">提示：国内域名/.cc域名暂不支持</p>
              </div>
            </div>
            <div v-if="pCode == MatchProId['DOMAIN_SECRURITY_LOCK']"
                 class="">
              <img class=" bgGreen pro-icon inbl"
                   src="../static/assets/icon-lock.png">
              <div class="pro-title inbl top">
                <div class="pro-title-name">域名安全锁</div>
                <p>为您的域名加“锁”，保障您的域名信息不被误修改或恶意篡改！</p>
              </div>
            </div>
          </div>
          <div class="config-panel">
            <div class="pt20">选择配置</div>
            <div class="config-panel-item">
              <div class="config-label inbl middle">绑定域名：</div>
              <div class="config-selbox inbl middle pl10">
                {{checkedDomain_show}}
                <a class="close"
                   @click="delGateWayHandler"
                   v-show="checkedDomain_show != ''">×</a>
              </div>
              <!-- <input class="inbl middle add-domain" type="button" value="添加域名 >" @click="openDomainDialog" /> -->
              <span class="add-domain"
                    @click="openDomainDialog">添加域名 ></span>
            </div>
            <div class="config-panel-item"
                 v-if="buyType.unitNumData.status == true">
              <div class="config-label inbl middle">购买数量：</div>
              <el-input-number size="mini"
                               @change="changeNum"
                               v-model="postData.goodsNum"
                               :min="buyType.unitNumData.min"
                               :max="buyType.unitNumData.max"
                               :step="buyType.unitNumData.step"
                               label="请选择"
                               controls-position="right"
                               :disabled="buyType.unitNumData.max == buyType.unitNumData.min"></el-input-number>
              <div class="sel-desc inbl middle f12">
                {{buyType.unitNumData.min}}{{buyType.unitNumData.unit}}起售，最多可购买{{buyType.unitNumData.max}}{{buyType.unitNumData.unit}}
              </div>
            </div>
            <div class="config-panel-item"
                 v-if="buyType.unitTimeData.status == true">
              <div class="config-label inbl middle">选购时长：</div>
              <div class="config-timeLang inbl middle">
                <el-select size="mini"
                           @change="changeTimeLong"
                           v-model="postData.timeLong"
                           placeholder="请选择"
                           :disabled='postData.isSyncMainTime'>
                  <el-option v-for="(sitem, index) in buyType.unitTimeData.list"
                             :key="index"
                             :label="sitem.label"
                             :value="sitem.value">
                  </el-option>
                </el-select>
                <!-- <div class="sel-desc inbl">个月</div> -->
                <div class="sel-desc inbl"
                     v-if="isInstList">
                  <label for="syncMainTime"><input class="mr5"
                           id="syncMainTime"
                           type="checkbox"
                           v-model="postData.isSyncMainTime"
                           @change="isSyncMainTime($event,buyType.unitTimeData.list)">与域名业务时长保持一致</label>
                </div>
              </div>
            </div>

          </div>
          <ul class="service">
            <li>7×24小时人工服务</li>
            <li>365天不间断技术运营保障体系</li>
            <li>功能全面的域名自助管理平台</li>
          </ul>
          <el-tabs class="app-detail-tabs"
                   style="min-height: 200px;"
                   v-model="defaultTab">
            <el-tab-pane label="　产品详情　"
                         name="first">
              <div class="content">
                <section v-if="pCode == MatchProId['MANMADE_MODIFY_DNS']">
                  <b>服务规则</b>
                  <p>1、本服务只为在中企注册的域名提供服务。非中企注册域名，请您联系您的域名服务商。
                    <br>2、每次人工服务，只为本服务绑定的域名操作，如果其他域名也需要，请为域名购买人工服务。
                    <br>3、服务流程：
                    <br>a、成功购买
                    <br>b、会员中心发起人工服务申请
                    <br>c、服务人员会在30分钟内和您电话沟通具体细节
                    <br>d、协助您修改域名DNS服务器
                    <br>e、等待DNS更新生效</p>
                  <b>所需条件</b>
                  <p>用户需提供新的域名DNS服务器名称</p>
                  <b>注意事项</b>
                  <p>1、一旦域名正式使用了,中途修改DNS,可能会造成网站中断24小时。因为DNS变更需要24-48小时的时间；
                    <br>2、建议修改为新DNS前，将此域名的解析记录在新DNS中提前添加好，可减少解析中断的影响。</p>
                  <b>服务保障</b>
                  <p>7*24小时人工服务
                    <br>30分钟响应服务</p>
                </section>
                <section v-if="pCode == MatchProId['MANMADE_DOMAIN_RESOLUTION']">
                  <b>服务规则</b>
                  <p>1、本服务只为在中企注册，并且由中企提供域名解析的域名提供服务。
                    <br>2、每次人工服务，只为本服务绑定的域名操作，如果其他域名也需要，请为域名购买人工服务。
                    <br>3、每次服务，最多可以协助设置10条解析记录。
                    <br>4、服务流程：
                    <br>a、成功购买
                    <br>b、会员中心发起人工服务申请
                    <br>c、服务人员会在30分钟内和您电话沟通具体细节
                    <br>d、协助您配置解析
                    <br>e、等待解析生效</p>
                  <b>所需资料</b>
                  <p>用户需提供指定域名的服务类型（如增、删、改）以及对应的解析值</p>
                  <b>注意事项</b>
                  <p>解析值如果提供错误，需要重新修改，均需要时间，所以，请务必核对好信息。</p>
                  <b>服务保障</b>
                  <p>7*24小时人工服务
                    <br>30分钟响应服务</p>
                </section>
                <section v-if="pCode == MatchProId['MANMADE_PASS_DOMAIN']">
                  <b>服务规则</b>
                  <p>1、本服务只为在中企注册的域名提供服务。非中企注册域名，请您联系您的域名服务商。
                    <br>2、每次人工服务，只为本服务绑定的域名操作，如果其他域名也需要，请为域名购买人工服务。
                    <br>3、服务流程：
                    <br>a、成功购买
                    <br>b、会员中心发起人工服务申请
                    <br>c、服务人员会在30分钟内和您电话沟通具体细节
                    <br>d、如果您没实名认证通过的模板，会先协助您办理模板实名审核。
                    <br>e、审核通过，办理域名过户业务，等待过户结果</p>
                  <b>所需资料</b>
                  <p>1、按注册局要求，域名应过户到实名认证通过的信息模板上；如果您没有实名通过的信息模板，需请您按照中企的要求提供相关实名认证资料。
                  </p>
                  <b>注意事项</b>
                  <p>域名所有者变更需满足的条件
                    <br>1、域名处于正常状态，如果您已经为域名开启安全锁、或者whois隐私保护服务，请您提前关闭。
                    <br>2、域名不处于司法机构、仲裁机构或域名争议解决机构处理期间。
                    <br>3、域名注册成功并在有效期内，如果已经过期，请您先完成续费。</p>
                  <b>服务保障</b>
                  <p>7*24小时人工服务；
                    <br>30分钟响应服务。</p>
                </section>
                <section v-if="pCode == MatchProId['MANMADE_REALNAME']">
                  <b>所需资料</b>
                  <p>根据注册局规定，域名必须要完成实名认证才能正常解析使用，如规定时间内未完成实名认证，域名会处于锁定状态（Serverhold），无法正常解析使用；</p>
                  <b>服务规则</b>
                  <p>1、本服务只为在中企注册的域名提供服务。非中企注册域名，请您联系您的域名服务商。
                    <br>2、每次人工服务，只为本服务绑定的域名操作，如果其他域名也需要，请为域名购买人工服务。
                    <br>3、此服务仅适用于通过中企注册的未实名审核通过的域名
                    <br>4、服务流程：
                    <br>a、成功购买
                    <br>b、会员中心发起人工服务申请
                    <br>c、服务人员会在30分钟内和您电话沟通具体细节
                    <br>d、请您按照服务人员的要求，配合提供相应信息和实名认证资料
                    <br>e、服务人员会对您的资料初审
                    <br>f、正式提交，等待最终结果</p>
                  <b>所需资料</b>
                  <p>1、个人身份需提供：身份证、护照、港澳居民来往内地通行证、台湾居民来往大陆通行证、外国人永久居留身份证；
                    <br>2、 企业身份需提供：工商营业执照、组织机构代码证、统一社会信用代码证书、部队代号、军队单位对外有偿服务许可证、事业单位法人证书、外国企业常驻代表机构登记证、社会团体法人登记证书、宗教活动场所登记证、民办非企业单位登记证书、基金会法人登记证书、律师事务所执业许可证、外国在华文化中心登记证、外国政府旅游部门常驻代表机构批准登记证、司法鉴定许可证、社会服务机构登记证书、民办学校办学许可证、医疗机构执业许可证；
                    <br>3、以上资料需要提供真实、有效、清晰的图片，同时提供的信息必须真实、有效、准确的信息。</p>
                  <b>注意事项</b>
                  <p>正式提交后，如果实名制审核未通过，服务人员会主动联系您，或者您也可以主动联系中企服务人员确认，我们会根据具体失败原因，请您配合提供相关资料和信息，做再次的申请。</p>
                  <b>服务保障</b>
                  <p>7*24小时人工服务；
                    <br>30分钟响应服务</p>
                </section>
                <section v-if="pCode == MatchProId['ENTERPRICE_DNS']">
                  <b>什么是高防DNS？</b>
                  <p>拥有防御攻击能力的DNS服务。是基础DNS服务功能（域名解析）+防护能力（抵御DNS查询攻击）的域名增值服务产品。根据不同的防护能力级别，有不同版本的DNS服务</p>
                  <b>服务规则</b>
                  <p>1、本服务只为在中企注册的域名提供服务。非中企注册域名，请您联系您的域名服务商。
                    <br>2、仅为绑定的域名提供防护服务，如果其他域名也需要，请为域名购买高防DNS服务。
                    <br>3、本服务为按年售卖，或和您的保持服务期限，最低售卖一个月。
                    <br>4、本服务为购买成功，及开始计费。
                    <br>5、您可以会员中心内，查看此域名的解析详细日志
                  </p>
                  <b>注意事项</b>
                  <p>1、如果域名距离到期不足一个月，请您先办理域名续费，再购买此服务。
                    <br>2、已经购买本服务的域名，不可重复购买。
                    <br>3、如果您之前未使用中企的DNS服务，请修改为中企dns，否则您无法享受到中企DNS的防护服务。
                    <br>4、改为中企DNS后，请及时添加解析记录。
                    <br>5、服务期限到期前，您需要及时为此服务办理续费，到期未续费，将自动降为基础版服务。</p>
                </section>
                <section v-if="pCode == MatchProId['WHOIS']">
                  <b>什么是whois隐私保护？</b>
                  <p>本服务是域名增值服务，即通过一定的技术手段适当保护用户的注册联系人、管理联系人、技术联系人、缴费联系人信息（使用户提交的有关注册信息不在域名whois数据库中公开显示）。 通过此项服务，可以保护您的个人隐私不被公开，减少垃圾邮件和针对个人信息的窃取等。</p>
                  <b>whois信息保护购买成功后，域名whois信息就被保护了吗？</b>
                  <p>购买成功后，您需要到会员中心内对此域名操作服务“开启”操作，完成后，域名whois信息才会处于保护中。</p>
                  <b>开启whois信息保护服务，是否会变更域名的所有权？</b>
                  <p>不会，您仍然是域名的合法持有者并对域名拥有完全的控制权。</p>
                  <b>开启whois信息保护服务，是否影响域名正常的解析服务？</b>
                  <p>不会，域名解析服务正常使用。</p>
                  <b>服务规则</b>
                  <p>1、本服务按照“开启”次数售卖，开启保护前，需提前购买。关闭保护无需购买，但再次开启需要二次购买。
                    <br>2、本服务仅支持“.biz”，“.mobi”，“.com”，“.net”，“.info”，“.集团”，“.中文网”，“.企业”，“.手机”后缀。其他后缀暂不支持。
                    <br>3、本服务只为在中企注册的域名提供服务。非中企注册域名，请您联系您的域名服务商。
                    <br>4、仅为绑定的域名提供服务，如果其他域名也需要，请为域名购买隐私保护服务。</p>
                  <b>注意事项</b>
                  <p>如果您需要办理“域名所有人变更”（域名过户）服务，需要您提前关闭此隐私保护服务。</p>
                </section>
                <section v-if="pCode == MatchProId['DOMAIN_SECRURITY_LOCK']">
                  <b>所需资料</b>
                  <p>域名安全锁可以有效的保护域名的注册信息和域名安全，建议所有客户都应该提高域名安全意识，尽快使用域名安全锁服务。</p>
                  <b>什么是域名安全锁？</b>
                  <p>是一种域名增值服务，即通过一定的技术手段适当保护用户的域名注册信息（即whois信息，包括域名联系人信息、地址、电话、电子邮箱、DNS信息等）不被错误修改或恶意修改。通过此项服务，可以对您的域名进行加锁，保护您的域名信息不被修改。</p>
                  <b>购买完成，就自动为域名加锁吗？</b>
                  <p>购买成功后，您需要到会员中心内对此域名操作服务“开启”操作，完成后，此域名才会加上安全锁。</p>
                  <b>开启后，域名解析的管理是否受到影响？</b>
                  <p>不会，域名安全锁只是对域名的管理相关行为操作做限制，续费业务、解析服务不会受到影响。</p>
                  <b>服务规则</b>
                  <p>1、本服务按照“开启”次数售卖，开启保护前，需提前购买。关闭保护无需购买，但再次开启需要二次购买。
                    <br>2、本服务只为在中企注册的域名提供服务。非中企注册域名，请您联系您的域名服务商。</p>
                  <b>注意事项</b>
                  <p>开启安全锁会限制域名信息变更（包括过户业务），修改DNS业务、转移注册商服务，所以，如果您需要办理以上业务，请提前关闭域名安全锁。
                    <br>并且，我们建议，在开启前，请提前考虑近期是否需要办理以上业务，提前安排好后，再开启安全锁服务。</p>
                </section>
              </div>
            </el-tab-pane>
            <el-tab-pane label="示例展示"
                         v-if="pCode == MatchProId['WHOIS'] || pCode == MatchProId['DOMAIN_SECRURITY_LOCK']">
              <section v-if="pCode == MatchProId['WHOIS']">
                <img src="../static/assets/u75.png"
                     alt="">
                <img src="../static/assets/u76.png"
                     alt="">
              </section>
              <section v-if="pCode == MatchProId['DOMAIN_SECRURITY_LOCK']">
                <p>开通域名安全锁后，域名各项功能保护状态如下，如需修改如下信息您需登陆并通过验证才能进行修改。</p>
                <img src="../static/assets/u81.png"
                     alt="">
              </section>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <recommend style="margin-bottom:18px;"></recommend>
    </div>

    <el-dialog title="绑定域名"
               :visible.sync="visibleBindDomain"
               width="550px"
               :lock-scroll="false">
      <div v-loading="loadingDomainData">
        <div class="f12 p20 domain-dialog-content"
             v-if="domainList.length > 0">
          <el-radio-group v-model="checkedDomain">
            <el-radio v-for="(item,index) in domainList"
                      :key="index"
                      :label="item.id">{{item.domain}}</el-radio>
          </el-radio-group>
        </div>
        <div v-else>
          <p class="ymbd-tip">当前会员账户下没有可管理的域名，如需购买服务，您需要先进行域名注册或转入已有域名</p>
          <a href="/domain"
             class="ymbd-a1">注册域名</a>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="visibleBindDomain = false">取 消</el-button>
        <el-button type="primary"
                   @click="checkDomain">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>
<script>
import rightBarScroll from '../static/scripts/rightBarScroll'
import banner from './components/header'
import recommend from './components/recommend'
import cTitle from './components/title'
import * as $_MatchProId from '../static/scripts/product-id.const'
export default {
  data () {
    return {
      pId: '',
      pCode: '',
      visibleBindDomain: false,
      initData: {
        goodsName: ''
      },
      defaultTab: 'first',
      attrData: {},
      domainList: [],
      checkedDomain: '',
      checkedDomain_show: '',
      checkedInstCode: '',
      buyType: {
        unitNumData: {
          min: 0,
          max: 0,
          step: 0,
          unit: '',
          code: '',
          status: false
        },
        unitTimeData: {
          unit: '',
          list: [],
          code: '',
          status: false
        }
      },
      MatchProId: $_MatchProId,
      isInstList: true,
      loadingDomainData: false,
      postData: {
        businessType: '1', //1:新购；2:续费
        source: 'AFFICIAL_WEBSITE', //来源,商店:APP_STORE;官网:AFFICIAL_WEBSITE
        skuId: '', //skuId,页面上可以取到
        mainInstanceCode: '', //主商品实例code
        extInstanceCode: '', //扩展实例code
        goodsNum: 0, //购买数量
        timeLong: '', //购买年限
        isSyncMainTime: false //是否与主体保持一致
      },
      timeLongDis: false
    }
  },
  watch: {
    $route (to, from) {
      // 对路由变化作出响应...
      this.pCode = to.params.code
      this.defaultTab = 'first'
      this.delGateWayHandler()
      this.$_getDetail()
    }
  },
  components: {
    banner,
    recommend,
    cTitle
  },
  created () {
    this.pCode = this.$route.params.code
    this.$_getDetail()
  },
  mounted () {
    // $(".appDetail .protect-right").css("top",$(".protect-center").offset().top + 'px')
    // console.log($(".appDetail .protect-right").css('top'))
  },
  methods: {
    $_getDetail () {
      if (
        window.__PRERENDER_INJECTED &&
        window.__PRERENDER_INJECTED.prerender === 'domain'
      ) {
        return
      }
      // $.get('/security/domainGoods/detail',{id: this.pId,type: '1'}).then(res=>{
      //   this.initData  = res.data
      //   this.postData.skuId = res.data.skuVoList[0].id
      // })
      $.get('/security/domainGoods/detailByCode', {
        code: this.pCode,
        type: '1'
      }).then(res => {
        if (res.status) {
          this.$message.error(res.msg)
          return
        } else {
          this.initData = res.data
          this.pId = this.initData.id
          this.postData.skuId = res.data.skuVoList[0].id
        }
      })
    },
    jumpkf53(){
      this.$router.push('https://tb.53kf.com/code/client/10168926/3')
    },
    // 立即购买，跳转至确认订单
    immediatelyBuy () {
      this.$router.push({
        path: '/domain/confirm/' + JSON.stringify([this.postData])
      })
    },
    openDomainDialog () {
      this.domainList = []
      this.checkedDomain = ''
      this.checkedDomain_show = ''
      this.$_getInstList()
      this.visibleBindDomain = true
    },
    checkDomain () {
      this.visibleBindDomain = false
      if (this.checkedDomain == '') {
        return false
      }
      this.domainList.forEach(element => {
        if (element.id == this.checkedDomain) {
          this.checkedDomain_show = element.domain
          this.checkedInstCode = element.instanceCode
          this.postData.mainInstanceCode = this.checkedInstCode
        }
      })
      this.enterGateWayHandler()
    },
    $_getInstList () {
      this.loadingDomainData = true
      $.get('/security/domainGoods/instList', { goodsId: this.pId }).then(
        res => {
          this.domainList = res.data || []
          this.loadingDomainData = false
        },
        err => {
          this.loadingDomainData = false
        }
      )
    },
    // 删除主体
    delGateWayHandler () {
      this.checkedDomain = ''
      this.postData.goodsNum = 0
      this.postData.timeLong = ''
      this.checkedDomain_show = ''
      this.checkedInstCode = ''
      this.postData.mainInstanceCode = ''
      this.buyType.unitNumData.status = false
      this.buyType.unitTimeData.status = false
    },
    // 选择主体
    enterGateWayHandler () {
      //获取商品可用产品实例对应属性
      $.get('/security/domainGoods/findAttr', {
        goodsId: this.pId,
        instCode: this.checkedInstCode
      }).then(response => {
        response.attrList.forEach(v => {
          this.attrList(v)
        })
        this.postData.goodsNum = this.buyType.unitNumData.min
        this.$_dynamicPrice(this.buyType.unitNumData.min)
      })
    },
    //展示商品属性方法
    attrList (v) {
      if (v.goodsAttribute.attrubuteCode == 'NUM') {
        v.attrValueList.forEach(vnl => {
          this.buyType.unitNumData = {
            code: v.goodsAttribute.attrubuteCode,
            min: vnl.minValue,
            max: vnl.maxValue,
            step: vnl.stepLen,
            unit: vnl.unitName,
            status: true
          }
        })
      } else if (v.goodsAttribute.attrubuteCode == 'TIME_LONG') {
        this.buyType.unitTimeData.list = []
        v.attrValueList.forEach((vtl, itl) => {
          let ValUnit = String(vtl.defaultVal + vtl.unitName)
          this.buyType.unitTimeData.list.push({
            label: ValUnit,
            value: vtl.defaultVal
          })

          this.postData.timeLong = this.buyType.unitTimeData.list[0].value
          this.buyType.unitTimeData.code = v.goodsAttribute.attrubuteCode
          this.buyType.unitTimeData.status = true
        })
      }
    },

    isSyncMainTime (val, item) {
      this.timeLongDis = val
      if (val) {
        this.postData.timeLong = item[item.length - 1].value
      } else {
        this.postData.timeLong = item[0].value
      }
      this.$_dynamicPrice()
    },
    changeNum (num) {
      this.postData.goodsNum = num
      this.$_dynamicPrice()
    },
    changeTimeLong (timel) {
      this.postData.timeLong = timel
      this.$_dynamicPrice()
    },
    $_dynamicPrice () {
      console.log(this.postData.goodsNum, 'num')
      $.get('/security/domainGoods/findPrice', {
        goodsId: this.pId,
        goodsSkuId: this.postData.skuId,
        buyTime: this.postData.timeLong,
        buyNum: this.postData.goodsNum,
        instCode: this.checkedInstCode
      }).then(response => {
        if (response.goodsSheetModel.buyNum == this.postData.goodsNum) {
          this.initData.minPrice = response.goodsSheetModel.payPrice
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import "../static/css/app-detail-common.scss";
@import "../static/css/app-detail.scss";
</style>



// WEBPACK FOOTER //
// src/app-detail.vue